import React from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { displayLoginPrompt } from "../../actions";
import Header from "../../components/Layout/Header";
import ReviewContainer from "../../containers/Review/ReviewContainer";
import Zoom from "../../components/Zoom";
import LoginPrompt from "../../components/LoginPrompt";
import withRouter from "../../services/utils/withRouter";

class Review extends React.Component {
  state = {
    loginPromptClosing: false,
    redirect: false,
    isZoomed: false
  };

  handleZoom = () => {
    this.setState({ isZoomed: !this.state.isZoomed });
  };

  handleCloseLoginPrompt = () => {
    this.setState({ loginPromptClosing: true });

    setTimeout(() => {
      this.setState({ loginPromptClosing: false });
      this.props.displayLoginPrompt(false);
    }, 300);
  };

  UNSAFE_componentWillUpdate(prevProps) {
    // Redirect to new design ID if the ID changes after saving
    if (this.props.design.id && prevProps.design.id !== this.props.design.id) {
      this.setState({
        redirect: true
      });
    }
  }

  render() {
    const { design, zoomed, location, params } = this.props;
    const designId = design.id;
    const updateUrl = `/${designId}/review`;

    return (
      <div className="wrapper">
        {this.state.redirect && (
          // Redirect if design ID changes
          <Navigate to={{ pathname: updateUrl, search: location.search }} />
        )}

        <div className="content">
          <Header
            currentPage="review"
            routeId={params.id}
            location={location}
            areAnyColorsOutOfStock={false}
          />

          <ReviewContainer
            routeId={params.id}
            location={location}
            handleZoom={(event) => this.handleZoom(event)}
          />

          {this.state.isZoomed && <Zoom handleZoom={this.handleZoom} />}

          {design.displayLoginPrompt && (
            <LoginPrompt
              handleCloseLoginPrompt={this.handleCloseLoginPrompt}
              loginPromptClosing={this.state.loginPromptClosing}
            />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
    zoomed: state.zoomed.active
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      displayLoginPrompt
    },
    dispatch
  );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Review));
